import FormAngketOTM from "../components/FormAngketOTM/Home";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <FormAngketOTM/>
    </div>
  );
}
